import Vue from "vue";
import Child from "./Child";
import Navbar from "./Navbar";
import NavbarBurger from "./NavbarBurger";

// Components that are registered globaly.
[Child, Navbar, NavbarBurger].forEach(Component => {
  Vue.component(Component.name, Component);
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js